import { auth } from "utils/firebase";

const getFirebaseIdToken = async () => {
  return auth.currentUser?.getIdToken();
};

export default getFirebaseIdToken;
